import React from 'react';
import './eventdetails.css'
import { supabase } from '../supabase';
import { useState } from 'react';
import { useEffect} from 'react';
import Cta from '../components/common/cta';
import SecCta from '../components/common/secondarycta';
import pic14 from '../assets/pic14.png'

import pic22 from '../assets/pic22.png'
import pic23 from '../assets/pic23.png'
import pic24 from '../assets/pic24.png'
import { useNavigate } from 'react-router-dom';

const Eventdetailssec = () => {



 const [content, setcontent]= useState([]);
      useEffect(() => {
      const getcontent = async()=>{
          const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;;
    
      setcontent(res.data);
      }
      getcontent();
      }, []);



 const [event, setevent]= useState([]);
      useEffect(() => {
      const getevent = async()=>{
          const res = await supabase.from('exbition_event').select('*').order('id', { ascending: true });;;
    
      setevent(res.data);
      }
      getevent();
      }, []);



const [tickets, setTickets] = useState([]);

useEffect(() => {
  const getTickets = async () => {
    const res = await supabase
      .from('ticket')
      .select('name, price')
      .eq('event_id', event?.[0]?.id);

    setTickets(res.data);
  };

  if (event?.length > 0) {
    getTickets();
  }
}, [event]);

const ticketText = tickets
  ?.map(t => `${t.name} (${t.price} EGP)`)
  .join(' - ');



const [showFullDesc, setShowFullDesc] = useState(false);
const [showFullTicket, setShowFullTicket] = useState(false);



const navigate = useNavigate();




    return ( 
 <section className='notification-sec'>
            <section className='map-container-sec'>
                    <section className='container-header-notification'>
                        <img src={pic14} alt='back'   onClick={() => navigate(-1)}   ></img>
                         <h1 className='header-map-section '>{content?.[26]?.header}</h1>
                    </section>

                    <section className='container-eventtdetails-box '>
                        <nav className='container-cta-map'>
                            <button className='button-containerr-map'>
                                <Cta title={content?.[26]?.cta}/>
                               
                            </button>
                              <button className='button-containerr-map'>
                             <SecCta title={content?.[26]?.cta2}/>
                             </button>
                        </nav>


                        <section className='event-details-card'>
                                <article className='box1-event-details-card'>
                                    <img src={event?.[0]?.img} alt='event-img'></img>
                                    <h1 className='header-event-details'>{event?.[0]?.event_name}</h1>
                                </article>

                                <article className='box2-event-details'>
                                        <div className='line-card-event-details'></div>
                                        <article className='information-event'>
                                            <article className='container-information-event-detailss'>
                                                <img src={pic22} alt='location'></img>
                                                <h2 className='event-informationn-event'>{event?.[0]?.location}</h2>
                                            </article>

                                            <article className='container-information-event-detailss'>
                                                <img src={pic23} alt='ticket'></img>
                                                <h2 className='event-informationn-event'>  {ticketText}</h2>
                                            </article>


                                            <article className='container-information-event-detailss'>
                                                <img src={pic24} alt='time'></img>
                                                <h2 className='event-informationn-event'>{event?.[0]?.time}</h2>
                                            </article>

                                           <p className={`pargraph-event-details ${showFullDesc ? 'expanded' : ''}`}>
                                                {event?.[0]?.description}
                                                </p>
                                                <span 
                                                className="read-more-link"
                                                onClick={() => setShowFullDesc(!showFullDesc)}
                                                >
                                                {showFullDesc ? 'Read less' : 'Read more'}
                                                </span>

                                                <p className={`pargraph-event-details ${showFullTicket ? 'expanded' : ''}`}>
                                                {event?.[0]?.ticket_details_pargraph}
                                                </p>
                                                <span 
                                                className="read-more-link"
                                                onClick={() => setShowFullTicket(!showFullTicket)}
                                                >
                                                {showFullTicket ? 'Read less' : 'Read more'}
                                                </span>
                                        </article>

                                        <button className='container-cta-event-details'>
                                            <Cta title={content?.[26]?.cta3}/>
                                        </button>

                                </article>

                        </section>




                        
                    </section>
            </section>
        </section>
     );
}
 
export default Eventdetailssec;